import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    component: HomeView,
  },
  {
    path: "/index",
    redirect: "/",
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "newsEdit" */ "../views/LoginView.vue"),
  },
  {
    path: "/newsEdit",
    name: "newsEdit",
    component: () =>
      import(/* webpackChunkName: "newsEdit" */ "../views/newsEdit.vue"),
  },
  {
    path: "/result",
    name: "result",
    component: () =>
      import(/* webpackChunkName: "result" */ "../views/ResultView.vue"),
  },
  {
    path: "/news",
    name: "news",
    component: () =>
      import(/* webpackChunkName: "news" */ "../views/NewsView.vue"),
  },
  {
    path: "/history",
    name: "history",
    component: () =>
      import(/* webpackChunkName: "news" */ "../views/HistoryView.vue"),
  },
  {
    path: "/resource",
    name: "resource",
    component: () =>
      import(/* webpackChunkName: "resource" */ "../views/ResourceView.vue"),
  },
  {
    path: "/database",
    name: "database",
    component: () =>
      import(/* webpackChunkName: "database" */ "../views/DatabaseView.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
